var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var moment = require("moment");

require("data/progress_graph.scss");

class ProgressGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { loadedDependencies: false }
	}

	render() {

		var graphDescription = (
			<div className="graphDescription">
				Your students' scaled critical thinking scores compared to the class and national average for students in a similar demographic.
			</div>
		);

		if (!this.state.loadedDependencies) {
			return (
				<div className="progressGraph">
					{ graphDescription }
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		var rawData = this.props.progressData[this.props.activeStudentList.id];
		if (rawData) {
			var baselineData = _.indexBy(rawData.baseline, "quarter_index");
			var groupData = _.indexBy(rawData.group_results, "start");
			var studentData = _.indexBy(rawData.user_results[this.props.activeStudent.id], "start");

			var schoolYearStart = CurrentUser.fetchSchoolYearDates().startDate;
			var startDates = _.last(_.pluck(_.sortBy(rawData.group_results, "start"), "start"), 4);
			startDates = _.reject(startDates, function(startDate) {
				return moment(startDate) < moment(schoolYearStart).subtract(3, "months")
			});

			var progressData = _.times(4, function(index) {
				var startDate = startDates[index];

				if ((!startDate) || (!groupData[startDate])) {
					var startMonth = moment(startDates[0]).add(index * 3, "months").format("MMM");
					var endMonth = moment(startDates[0]).add((index * 3) + 2, "months").format("MMM");
					var labelText = startMonth + " - " + endMonth;
					return {
						National: (Math.round(baselineData[index].value * 200)),
						label: labelText
					}
				} else {
					var endDate = groupData[startDate].end;
					var labelText = moment(startDate).format("MMM") + " - " + moment(endDate).format("MMM");

					if (studentData[startDate]) {
						var studentValue = (Math.round(studentData[startDate].value * 200));
					} else {
						var studentValue = null;
					}

					return { 
						start: startDate, end: groupData[startDate].end,
						National: (Math.round(baselineData[index].value * 200)),
						Class: (Math.round(groupData[startDate].value * 200)),
						Student: studentValue,
						label: labelText
					}
				}
			});
		}

		if (_.isEmpty(progressData)) {
			return (
				<div className="progressGraph">
					{ graphDescription }
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		var chartWidth = this.props.width || 620;
		var chartHeight = this.props.height || 300;
		if (this.props.isAnimationActive === undefined) {
			var isAnimationActive = true;
		} else {
			var isAnimationActive = this.props.isAnimationActive;
		}

		return (
			<div className="progressGraph">
				{ graphDescription }
				<Recharts.LineChart width={ chartWidth } height={ chartHeight } data={ progressData }>
					<Recharts.XAxis dataKey="label"/>
					<Recharts.YAxis name="Scaled Score" domain={ ["auto", "auto"] } />
					<Recharts.CartesianGrid stroke="#eee" />
					<Recharts.Legend wrapperStyle={ { bottom: "-10px" } } />
					<Recharts.Line isAnimationActive={ isAnimationActive } type="monotone" dataKey="National" 
						stroke="#555" strokeDasharray="5 5" shape="circle" />
					<Recharts.Line isAnimationActive={ isAnimationActive } type="monotone" dataKey="Class" 
						stroke="#0082c8" shape="circle" />
					<Recharts.Line isAnimationActive={ isAnimationActive } type="monotone" dataKey="Student" 
						stroke="#68caff" shape="circle" />
				</Recharts.LineChart>
			</div>
		)
	}

	componentDidMount() {
		if (this.props.loadProgressF) {
			this.props.loadProgressF();			
		}

		$wr.loadScript("/dependencies/recharts.min.js", "Recharts", () => {
			this.setState({ loadedDependencies: true });
		});

	}
}

ProgressGraph.propTypes = StrictPropTypes({
	activeStudentList: PropTypes.object.isRequired,
	activeStudent: PropTypes.object.isRequired,
	progressData: PropTypes.object.isRequired,
	loadProgressF: PropTypes.func,
	width: PropTypes.number,
	height: PropTypes.number,
	isAnimationActive: PropTypes.bool
});

module.exports = ProgressGraph;


// WEBPACK FOOTER //
// ./modules/components/data/ProgressGraph.js